import type {DriverDay} from './schemas'

export function driversForYard(drivers: DriverDay[], yardId: string | null): DriverDay[] {
    return yardId == null
        ? drivers
        : drivers.filter((driver) => driver.homeDispatchYardId === yardId)
}

export function noHomeYardSummary(drivers: DriverDay[]): string | null {
    const withoutYard = drivers.filter((driver) => driver.homeDispatchYardId == null)
    if (withoutYard.length === 0) return null

    const available = withoutYard.filter((driver) => driver.state === 'available').length
    const noun = withoutYard.length === 1 ? 'driver' : 'drivers'
    return `${withoutYard.length} ${noun} with no home yard (${available} available)`
}
